enum SortType {
    Descending = -1,
    Ascending = 1,
}

export default SortType;